export default __webpack_public_path__ + "static/media/image_edificios.153aae7a.png";